'use client'

import React from 'react'
import styles from './styles.module.css'
import { processStrapiTextTags } from '@/components/StrapiContentRenderer'
import { convertRichTextToHTML } from '@/components/StrapiContentRenderer'

interface DescriptionData {
  description?: string | any
  desk_max_width?: string | number
}

interface DescriptionProps {
  data: DescriptionData
}

const processTextWithLineBreaks = (text: string | any): string => {
  if (!text) return ''
  
  let processed = ''
  if (typeof text === 'string') {
    processed = text.replace(/\n\n/g, '</p><p>').replace(/\n/g, '<br>')
    if (processed) {
      processed = `<p>${processed}</p>`
    }
    return processStrapiTextTags(processed)
  }
  
  if (Array.isArray(text)) {
    const html = convertRichTextToHTML(text)
    return processStrapiTextTags(html)
  }
  
  return processStrapiTextTags(String(text))
}

const Description: React.FC<DescriptionProps> = ({ data }) => {
  const description = processTextWithLineBreaks(data.description)

  if (!description) {
    return null
  }

  const descriptionStyle = data.desk_max_width 
    ? { maxWidth: `${data.desk_max_width}px` } 
    : undefined

  return (
    <section className={styles.descriptionBlock}>
      <div 
        className={styles.description}
        style={descriptionStyle}
        dangerouslySetInnerHTML={{ __html: description }}
      />
    </section>
  )
}

Description.displayName = 'Description'

export default Description

